import { createSelector } from 'reselect';
import { RECRUITER } from 'constants/index';

export const getJobPost = createSelector(
  (state: any) => state.user,
  (state: any) => state.jobPosts.allJobPosts,
  (state: any) => state.jobPosts.userJobPosts,
  (_: any, id: number) => id,
  (user, allJobPosts, userJobPosts, id) => {
    if (user.role === RECRUITER) {
      return allJobPosts.find((post: any) => post.id === id);
    }
    return userJobPosts.find((post: any) => post.id === id);
  }
);

export const getJobPostInitialValues = (initialValues: any) => {
  return (
    initialValues && {
      title: initialValues.title,
      type: initialValues.type,
      country: initialValues.country,
      state: initialValues.state,
      city: initialValues.city,
      requirements: initialValues.requirements,
      responsibilities: initialValues.responsibilities,
      info: initialValues.info,
      minSalary: initialValues.salary.min,
      maxSalary: initialValues.salary.max,
      firstSkill: initialValues.skills[0],
      secondSkill: initialValues.skills[1],
      thirdSkill: initialValues.skills[2],
      interviewsCount: initialValues.interviewsCount,
      isRequireRecruiter: initialValues.isRequireRecruiter ? 'yes' : 'no',
      linkToTest: initialValues.linkToTest,
      currency: initialValues.currency,
      compensationType: initialValues.compensationAsRate ? 'Percentage' : 'Sum',
      compensation: initialValues.compensation,
    }
  );
};
